import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { ILink } from 'tbk-components/src/components/Button';
import Map, { IMapMarker } from '../Map';
import comingSoonMessages, {
	ComingSoonMessages,
} from '../../lib/comingSoonMessages';

export interface IStoreHours {
	storeName?: string;
	storeHours?: string[];
	hoursNote?: string;
}

export interface ILocationMarker {
	marker?: IMapMarker;
}

export interface ILocationAbout {
	heading?: string;
	content?: string;
}

export interface IRelatedService {
	label?: string;
	href?: string;
}

export interface ISingleLocation {
	title?: string;
	address?: string;
	comingSoon?: ComingSoonMessages;
	phone?: string;
	linkDirections?: ILink;
	hoursIndividual?: IStoreHours[];
	marker?: IMapMarker;
	about?: ILocationAbout;
	relatedServices?: IRelatedService[];
}

export interface ISingleLocationProps extends IBaseElementProps {
	mapOptions?: google.maps.MapOptions;
	location?: ISingleLocation;
	displayLocationAbout?: boolean;
}

const SingleLocation: React.FC<ISingleLocationProps> = ({
	className,
	classNames = [],
	mapOptions = {},
	location,
	displayLocationAbout = false
}) => (
	<>
		<div className={className || cn('location-single', ...classNames)}>
			<div className="location-single__details">
				{location.title && <h2>{location.title}</h2>}
				{comingSoonMessages(location.comingSoon).map(
					(message, messageIndex) => (
						<p
							className="location-single__coming-soon"
							key={messageIndex}
						>
							{message}
						</p>
					),
				)}
				{location.address && (
					<address
						className="location-single__address"
						dangerouslySetInnerHTML={{
							__html: location.address.replace(/\\n/g, '<br />'),
						}}
					/>
				)}

				{location?.linkDirections?.href && (
					<div className="location-single__directions">
						<a
							href={`${location.linkDirections.href}`}
							target="_blank"
						>
							{location.linkDirections.label}
						</a>
					</div>
				)}

				{location.phone && (
					<div className="location-single__phone">
						<a href={`tel:${location.phone}`}>{location.phone}</a>
					</div>
				)}

				{Array.isArray(location.hoursIndividual) &&
					location.hoursIndividual.some(
						(hour) =>
							Array.isArray(hour.storeHours) &&
							hour.storeHours.length > 0,
					) && (
						<div className="location-single__hours">
							{location.hoursIndividual.map((hour, hourIndex) => (
								<div key={hourIndex}>
									<h4>{hour.storeName}</h4>
									{Array.isArray(hour.storeHours) && (
										<ul>
											{hour.storeHours.map(
												(storeHour, storeHourIndex) => (
													<li key={storeHourIndex}>
														{storeHour}
													</li>
												),
											)}
										</ul>
									)}
									{hour.hoursNote && (
										<p className="location-single__hours-note">
											{hour.hoursNote}
										</p>
									)}
								</div>
							))}
						</div>
					)}

				{Array.isArray(location.relatedServices) &&
					location.relatedServices.length > 0 && (
						<ul className="location-single__related-services">
							{location.relatedServices.map((service, index) => (
								<li key={index}>
									<a href={service.href}>{service.label}</a>
								</li>
							))}
						</ul>
					)}
			</div>
			<div className="location-single__map">
				<Map {...mapOptions} markers={[location.marker]} />
			</div>
		</div>

		{displayLocationAbout && (
			<div className="location-single__about">
				<h3>{location.about.heading}</h3>
				<p>{location.about.content}</p>
			</div>
		)}
	</>
);

export default SingleLocation;
